<template>
  <v-row>
    <v-col>
      <site-management-table :data="tableData"></site-management-table>
    </v-col>
  </v-row>
</template>

<script>
import { SITE_MANAGEMENT } from '@/libs/fakeData'
import SiteManagementTable from '@/components/Tables/SiteManagement'

export default {
  components: { SiteManagementTable },
  computed: {
    tableData () {
      return SITE_MANAGEMENT
    }
  }
}
</script>
